import type React from 'react';

import type { UserId } from '@vlabs/api/artemy/model';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import {
  UserDetailsGeneralInfo,
  UserDepartmentList,
  UserPermissionTagList,
  UserListList,
  UserPermissions,
} from '@vlabs/monokit/widgets';
import { useHasPermission } from '@vlabs/permissions';
import { useParams } from 'react-router-dom';

import { UserDetailsPageHeader } from './header/UserDetailsPageHeader';
import { UserDetailsInfo } from './info/UserDetailsInfo';
import st from './UserDetailsPage.module.sass';

function UserDetailsPage(): React.JSX.Element {
  const { userId } = useParams<{ userId: UserId }>();
  const canViewGroups = useHasPermission('group', 'read');
  const canViewLists = useHasPermission('list', 'read');
  return (
    <Page>
      <PageContent>
        <UserDetailsPageHeader userId={userId} />
        <div className={st.Root}>
          <div className={st.Content}>
            <div className={st.InfoSection}>
              <UserDetailsGeneralInfo userId={userId} />
              <UserDepartmentList userId={userId} />
              {!!canViewGroups && <UserPermissionTagList userId={userId} />}
              {!!canViewLists && <UserListList userId={userId} />}
            </div>
            <UserPermissions userId={userId} />
          </div>
          <div className={st.Info}>
            <UserDetailsInfo />
          </div>
        </div>
      </PageContent>
    </Page>
  );
}

export { UserDetailsPage };
